import type { FormKitOptionsProp } from '@formkit/inputs'

export async function useFetchCountries() {
  const { data: countries } = await useFetch<FormKitOptionsProp>('/countries', {
    server: false,
    method: 'get',
    baseURL: useRuntimeConfig().public.apiBaseURL,
    key: 'dbc-countries',
    deep: false,
    transform: (response: any) => {
      return response.data
        .map((country: { code: string; name: string }) => country.code)
        .sort()
    },
  })
  return countries
}
